import { render } from "./setpwd.vue?vue&type=template&id=18b4962a&scoped=true"
import script from "./setpwd.vue?vue&type=script&lang=js"
export * from "./setpwd.vue?vue&type=script&lang=js"

import "./setpwd.vue?vue&type=style&index=0&id=18b4962a&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\经济运行\\econo-eco-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b4962a"]])

export default __exports__